import type { VariantCatalog } from "../types";
import { matchesPrefix } from "./matchesPrefix";

export function resolveSelection(
  catalog: VariantCatalog,
  selection: readonly string[],
  index: number,
  value: string,
) {
  const prefix = selection.slice(0, index);
  prefix[index] = value;

  const candidates = catalog.combinations.filter((combination) =>
    matchesPrefix(combination, prefix),
  );

  if (!candidates.length) return selection.slice();

  const onlyCandidate = candidates[0];
  if (candidates.length === 1 && onlyCandidate)
    return onlyCandidate.values.slice();

  if (prefix.length === catalog.attributes.length) return prefix;

  const kept = candidates.filter((combination) =>
    selection.every(
      (selected, cursor) =>
        cursor <= index || combination.values[cursor] === selected,
    ),
  );

  const onlyKept = kept[0];
  if (kept.length === 1 && onlyKept) return onlyKept.values.slice();

  return prefix;
}
